import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';
import { EntityType, Locale, NotificationChannel } from '@frontend/common';

export interface Notification {
    channel: NotificationChannel | null;
    language: Locale | null;
    subject: string | null;
    body: string | null;
    cc_user_id: string | null;
    unique_identifier: string | null;
    delayed_timestamp: string | null;
    status: string;
    blobs: Array<{ account_id: string; entity_type: EntityType; entity_id: string }> | null;
    extra_entities: object | null;
    update_timestamp: string;
    template_id: string;
    content_id: string;
    user_id: string;
    id: string;
    account_id: string;
    creation_timestamp: string;
}

export enum NotificationStatus {
    FAILED = 'failed',
    PENDING = 'pending',
    SKIPPED = 'skipped',
    SUCCEEDED = 'succeeded'
}

export interface CreateNotification {
    channel?: NotificationChannel | null;
    language?: Locale | null;
    subject?: string | null;
    body?: string | null;
    template_id?: string;
    content_id?: string;
    user_id?: string;
    cc_user_id?: string | null;
}

enum QueryParams {
    ACCOUNT_ID = 'account_id',
    USER_ID = 'user_id',
    TEMPLATE = 'template_id',
    CONTENT_ID = 'content_id',
    CHANNEL = 'channel',
    TRACKING_NUMBER = 'tracking_number'
}
export type NotificationQueryParams = DefaultQueryParams & QueryParams;
export type NotificationListResponse = PaginatedResponse<Notification>;
